import { parseQuery } from 'utils/string';

const getCurrentReferencePeriod = (props: { location: { search: string } }): string | string[] | undefined => {
  return parseQuery(props.location.search).referencePeriod;
};

export default getCurrentReferencePeriod;
